export const COLORS = {
    active: "#33D69F",
    closed: "#FF4C61",
    pending: "#FFB800"
}

export const STATUS = {
    PENDING: "pending",
    ACTIVE: "active",
    CLOSED: "closed"
}

export const AVATARS = [
    '/assets/avatar.png',
    '/assets/avatar2.png',
    '/assets/avatar3.png',
    '/assets/avatar4.png'
]


export const CONTRACTADDRESS = "0xF0769e902743cf4C210deE8f0BF7C92A3EDD905c"
// export const CONTRACTADDRESS = "0x6Bdd02b119Db5BAf0A9Df2D68C7d1Cd7082b9220"
//export const CONTRACTADDRESS = "0xB692B11f454f9efd47475F6BCA77D94FcC1a1a22"